import { NewAcciones } from '../components/Acciones/NewAcciones';
import Layout from '../components/Layout';

export default function Acciones() {
	return (
		<div>
			<Layout />
			<div>
				<NewAcciones />
			</div>
		</div>
	);
}
